import React from "react";
import ContactInformation from "../components/cart/ContactInformation";
import OrderSummary from "../components/cart/OrderSummary";
import DeliveryMethod from "../components/cart/DeliveryMethod";
import PaymentMethod from "../components/cart/PaymentMethod";
import {useFormik} from "formik";
import {useBuy, useCart} from "../providers/queryClient";
import Header from "../components/header/Header";
import {Footer} from "../components/footer/Footer";

const Cart = () => {
    const {data} = useCart();
    const formik = useFormik<any>({
        initialValues: {},
        enableReinitialize: true,
        onSubmit: () => buy.mutate(),
    });

    const buy = useBuy();

    return (
        <div className="bg-gray-50">
            <Header/>
            <main className="mx-auto max-w-7xl px-4 pb-24 pt-16 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-2xl lg:max-w-none">
                    <h1 className="sr-only">Podsumowanie zamówienia</h1>
                    <form onSubmit={formik.handleSubmit} className="lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16">
                        <div>
                            <ContactInformation/>
                            <DeliveryMethod/>
                            <PaymentMethod/>
                        </div>

                        {/* Order summary */}
                        <OrderSummary/>
                    </form>
                </div>
            </main>
            <Footer/>
        </div>
    );
}

export default Cart;